// Dev-only deep-link into a specific onboarding step for visual QA + e2e.
// Reads `?onboardingStep=<screen>` from the URL and is INERT in production
// builds (`import.meta.env.DEV` is false there), so step-jumping can never be
// exposed to real users. The screen name is validated against the wizard's
// known steps by the caller before use.

export const ONBOARDING_STEP_PARAM = 'onboardingStep';

export function readDevOnboardingStep(): string | null {
	if (!import.meta.env.DEV) return null;
	if (typeof window === 'undefined') return null;
	const value = new URLSearchParams(window.location.search).get(
		ONBOARDING_STEP_PARAM,
	);
	return value && value.trim() !== '' ? value : null;
}
